import {
  DemoIndicatorColoredIcon,
  GlobalIcon,
  type IconProps,
  TourIndicatorColoredIcon,
} from '@carboncopyco/icons';
import type React from 'react';
import type { PlaybookAssetInternalSource, PlaybookAssetSource } from './types';

export const iconByAssetType: Record<
  PlaybookAssetSource,
  React.ReactElement<IconProps>
> = {
  demo: <DemoIndicatorColoredIcon />,
  tour: <TourIndicatorColoredIcon />,
  overlay: <DemoIndicatorColoredIcon />,
  externalUrl: <GlobalIcon />,
};
export const titleKeyByAssetType: Record<PlaybookAssetSource, string> = {
  demo: 'demoName',
  tour: 'tourName',
  overlay: 'demoName',
  externalUrl: 'name',
};

export const iconTitleByAssetType: Record<PlaybookAssetInternalSource, string> =
  {
    demo: 'Demo (cloned app)',
    overlay: 'Demo (live app)',
    tour: 'Tour',
  };

export const PLAYBOOK_ASSET_LIMIT = 20;
